import { forwardRef, useEffect } from "react";

export const AuthCallback = forwardRef((props, ref) => {

    useEffect(() => {

        // Send the message to the target, listen for a response
        localStorage.setItem('msAuth', parseInt(Math.random() * 10000));

        // Close this window
        window.close();

    }, []);

    return (<></>);

});

AuthCallback.displayName = 'AuthCallback';